import { getUserIdFromJid } from '@/shared/utils';
import { toggleMessageSelection, useMessageSelectionCount } from '@/features/chats/model';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { handleSelectMedia } from '@/features/chats/sub-features/media/utils/mediaUtils';

/**
 * Custom hook to manage message actions (selection, media handling, etc.).
 * @param {Object} message - The message object.
 * @param {string} activeChatJid - The JID of the active chat.
 * @returns {Object} Selection state and action handlers.
 */
export const useMessageAction = (message, activeChatJid) => {
   const dispatch = useDispatch();
   const activeChatId = useMemo(() => getUserIdFromJid(activeChatJid), [activeChatJid]);
   const { selectionCount, selectionType } = useMessageSelectionCount(activeChatId);

   const isSelectionActive = selectionCount > 0;
   const isSelected = !!message.isSelected;

   const handleToggleSelection = useCallback(() => {
      dispatch(
         toggleMessageSelection({
            chatId: activeChatId,
            msgId: message.msgId,
         }),
      );
   }, [dispatch, activeChatId, message.msgId]);

   const handleMediaClick = useCallback(
      (e, specificMsg) => {
         const targetMsg = specificMsg || message;
         handleSelectMedia({ message: targetMsg, activeChatJid, chatType: targetMsg.chatType || message.chatType });
      },
      [message, activeChatJid],
   );

   return {
      isSelected,
      isSelectionActive,
      selectionType,
      handleToggleSelection,
      handleMediaClick,
   };
};
